// Translations: NL (default), FR, EN
// Nested keys per section / page

const nl = {
  common: {
    explore: "ONTDEK",
    discover: "ONTDEK",
    view: "Bekijk",
    viewAll: "Bekijk alles",
    contactUs: "Neem contact op",
    sendMessage: "Verstuur",
    loading: "Laden...",
    of: "van",
    photos: "foto's",
    showAll: "Toon alle",
    notFound: "Niet gevonden",
    backTo: "Terug naar",
    name: "Naam",
    email: "E-mail",
    phone: "Telefoon",
    subject: "Onderwerp",
    message: "Bericht",
    sending: "Verzenden...",
    submit: "Verstuur",
    yourName: "Uw naam",
    home: "Thuispagina",
    callUs: "Bel ons",
    emailUs: "Stuur e-mail",
    requestQuote: "Vraag offerte",
    onAppointment: "Enkel open op afspraak",
    perCar: "Per auto",
    moreInfo: "Meer info",
  },
  nav: {
    offer: "Aanbod",
    services: "Diensten",
    ourCars: "Onze wagens",
    buyYourCar: "Wij kopen uw auto",
    sellMyCar: "Verkoop mijn auto",
    tradeIn: "Overname",
    aftersales: "Naverkoop & personalisatie",
    upcoming: "Verwacht",
    financing: "Financiering",
    sold: "Verkocht",
    about: "Over ons",
    contact: "Contact",
    login: "Aanmelden",
  },
  home: {
    badge: "Premium dealer sinds 2018",
    heroLine1: "Vind hier de wagen",
    heroLine2: "die bij u past.",
    heroLine3: "Premium, klaar om te rijden.",
    heroSubtitle1: "Persoonlijke begeleiding, premium selectie en",
    heroSubtitle2: "12 maanden wettelijke waarborg",
    heroSubtitle3: "— van uw eerste bezoek tot ver na de aankoop.",
    seeStock: "Bekijk voorraad",
    statsYears: "Jaar ervaring",
    statsSold: "Auto's verkocht",
    statsShowroom: "Showroom Lede",
    statsWarranty: "Waarborg",
    months: "mnd",
    scroll: "Scroll",
    stockOverline: "Onze voorraad",
    buyOverline: "Verkoop aan ons",
    sellOverline: "Wij verkopen voor u",
    premiumOverline: "Zorgvuldig geselecteerde",
    premiumTitle: "Premium",
    premiumTitleAccent: "wagens",
    fullOffer: "Volledig aanbod",
    viewCars: "Bekijk {n} Auto's",
    brandsLine: "Wij selecteren enkel topmerken",
    welcomeAt: "Welkom bij",
    aboutTitle: "Over",
    aboutTitleAccent: "ons",
    aboutText:
      "Kwalitatieve wagens van topmerken, met de nodige zorg en garantie. Bij TR Premium Cars staat u in rechtstreeks contact met de zaakvoerder voor een persoonlijke en transparante aankoopervaring.",
    aboutPoint1: "Beste prijs/kwaliteit verhouding",
    aboutPoint2: "Zorgvuldig geselecteerde wagens",
    aboutPoint3: "12 maanden wettelijke waarborg inbegrepen",
    aboutPoint4: "Persoonlijk en professioneel contact",
    aboutCta: "Ons verhaal",
    yearsExp: "jaar ervaring",
    valuesOverline: "Onze waarden en normen",
    valuesTitle: "Kopen in vertrouwen",
    valuesText:
      "Kopen bij TR Premium Cars, dat is kopen in vertrouwen. Wij selecteren enkel de beste voertuigen aan de beste prijzen.",
    valueShowroomTitle: "600 m² Showroom",
    valueShowroomText:
      "Al onze wagens zijn binnen te bezichtigen in een volledig verlichte ruimte, zodat u de wagen rustig kunt bekijken.",
    valueQualityTitle: "Top kwaliteit",
    valueQualityText:
      "Wij selecteren enkel kwalitatieve, aantrekkelijke wagens met onderhoudshistorie.",
    valueAdviceTitle: "Persoonlijk advies",
    valueAdviceText:
      "Als klant staat u centraal in contact met de zaakvoerder, de verantwoording en opvolging ligt dus bij 1 persoon die u kan contacteren.",
    valueTradeTitle: "Overnames",
    valueTradeText:
      "Wij proberen u altijd de beste prijs te geven voor uw overnamewagen, ook voor oudere wagens werken wij met een internationaal autoplatform om de beste prijzen aan te bieden.",
    testimonialsOverline: "Tevreden klanten",
    testimonialsTitle: "Wat klanten zeggen",
    ctaTitle1: "Klaar voor uw",
    ctaTitleAccent: "volgende",
    ctaTitle2: "wagen?",
    ctaText:
      "Kom langs in onze 600 m² showroom in Lede, of bel ons voor een vrijblijvend gesprek. Wij staan voor u klaar — op afspraak.",
    makeAppointment: "Maak afspraak",
    viewCarsShort: "Bekijk wagens",
  },
  stock: {
    title: "Onze",
    titleAccent: "Voorraad",
    keyword: "Sleutelwoord",
    readyOnly: "Ready",
    brand: "Merk",
    fuel: "Brandstof",
    body: "Carrosserie",
    clear: "Leeg alles",
    results: "Resultaten",
    sortBy: "Sorteer:",
    sortNewest: "Nieuwste",
    sortPriceAsc: "Prijs (laag-hoog)",
    sortPriceDesc: "Prijs (hoog-laag)",
    sortYearDesc: "Jaar (nieuwste)",
    sortKmAsc: "Kilometerstand (laagste)",
    noResults: "Geen resultaten gevonden.",
    loadFailedTitle: "Kon de wagens niet laden",
    loadFailedDesc: "Controleer uw internetverbinding en probeer opnieuw.",
    retry: "Opnieuw proberen",
    all: "Alle",
    reset: "Reset",
    resetFilters: "Filters wissen",
    ready: "READY!",
    reserved: "GERESERVEERD!",
    inPreparation: "IN VOORBEREIDING!",
    upcoming: "VERWACHT!",
    priceOnRequest: "Prijs op aanvraag",
  },
  car: {
    backToStock: "Terug naar voorraad",
    showAllPhotos: "Toon alle {n} foto's",
    noImage: "Geen afbeelding",
    notFound: "Auto niet gevonden",
    backToStockShort: "← Terug naar voorraad",
    year: "Jaar",
    km: "Kilometerstand",
    transmission: "Transmissie",
    bodyType: "Carrosserie",
    brand: "Merk",
    model: "Model",
    warranty: "Garantie",
    months12: "12 maanden",
    description: "Beschrijving",
    options: "Uitrusting & opties",
    allPhotos: "Alle foto's",
    price: "Prijs",
    askAboutThisCar: "Vraag over deze wagen",
    sendEmail: "Stuur e-mail",
    financoCta: "Of dien direct aanvraag in via Financo",
    optionsHeader: "Uitrusting & opties",
    relatedCars: "Gelijkaardige wagens",
    legalWarranty: "12 maanden wettelijke waarborg",
    cleaning: "Volledige reiniging binnen en buiten",
    carPass: "Car-pass & 75+ controlepunten",
    carPassLink: "Bekijk Car-Pass",
    vatDeductible: "BTW aftrekbaar",
    horsepower: "Vermogen",
    engineSize: "Cilinderinhoud",
    hp: "pk",
    cc: "cc",
    yourMessage: "Uw bericht...",
    sendInquiry: "Verstuur",
    fuel: "Brandstof",
    firstReg: "1e inschrijving",
    colorExt: "Kleur exterieur",
    colorInt: "Kleur interieur",
    inquirySubject: "Vraag over",
    inquiryToast: "Bericht verzonden",
    inquiryToastDesc: "Wij nemen zo snel mogelijk contact met u op.",
    sendFailed: "Versturen mislukt",
    sendFailedDesc: "Probeer opnieuw of bel ons.",
  },
  about: {
    overline: "Wie zijn wij",
    title: "Over",
    titleAccent: "ons",
    intro:
      "Welkom bij TR Premium Cars, waar wij garant staan voor kwalitatieve wagens tegen de beste prijzen op de markt. Neem gerust een kijkje naar één van onze prachtige bolides!",
    quote:
      '"You can\'t buy happiness, but you can buy cars and that\'s kind of the same thing."',
    storyP1:
      "Thibault Rasschaert begon enkele jaren geleden TR Premium Cars, dit uit een enorme passie voor auto's en ondernemen. In 2017 begon hij als 18-jarige jongeman met het aan- en verkopen van tweedehandswagens, de eerste was een Lexus IS F-Sport die snel een nieuwe eigenaar vond.",
    storyP2:
      "Vanaf dat moment had hij de smaak te pakken en wou hij TR Premium Cars op de kaart brengen. Hij werd begeleid door Auto federatie Traxio en 2 gereputeerde garages met jarenlange ervaring voor de controle en onderhoud op de voertuigen.",
    statsYears: "Jaren ervaring",
    statsOnRequest: "Auto's op aanvraag",
    statsSold: "Auto's verkocht",
    statsImports: "Import op aanvraag",
    timelineOverline: "Onze geschiedenis",
    timelineTitle: "Tijdlijn",
    hofOverline: "Hall of Fame",
    hofTitle: "Wagens die",
    hofTitleAccent: "geschiedenis schreven",
    hofIntro: "Een selectie van uitzonderlijke wagens die door onze handen gingen — stuk voor stuk geleverd met dezelfde zorg en passie.",
    hofBadge: "Verkocht",
    timeline: [
      { year: "2017", title: "Verkoop eerste auto", text: "De Lexus IS300h F Sport, prachtige wagen die mijn vader toen wou verkopen na 4 jaar als bedrijfswagen. Ik heb de overnameprijs van de garage geëvenaard en de wagen 3 weken later zelf verkocht." },
      { year: "2018", title: "Vennootschap opgericht", text: "TR Premium Cars werd opgericht 5 juni 2018 met de focus op prachtige, kwalitatieve wagens en correct garantiebeleid." },
      { year: "2023", title: "Opening showroom te Lede", text: "Na TR Premium Cars jarenlang op te bouwen en te zoeken naar een toegankelijke showroom blijven we in Lede te Kleiweg 27!" },
      { year: "2024", title: "Uitbreiding Showroom", text: "Onze huidige showroom wordt verdubbeld naar bijna 600 m²! Hier worden al onze stockwagens veilig en droog gestockeerd tot ze een nieuwe thuis hebben." },
      { year: "2025", title: "Parkeerliften", text: "Deze kwalitatieve parkeerliften zorgen voor meer verticale stockage, deze investering zorgt ervoor dat bij bezichtigingen of afleveringen de wagens droog en verzorgd blijven." },
    ],
    faqOverline: "FAQ",
    faqTitle: "Vaak gestelde vragen",
    faqs: [
      { q: "Wat voor garantie wordt er aangeboden?", a: "In elke aangeboden prijs zit standaard 12 maanden wettelijke waarborg. Zo bent u gerust van uw aankoop!" },
      { q: "Voeren jullie onderhouden uit?", a: "Wij focussen ons enkel op aan- en verkoop van wagens. En werken nauw samen met gespecialiseerde garages voor de controles, herstellingen en onderhoudsbeurten. Waar klanten steeds bij terechtkunnen." },
      { q: "Wat kunnen wij verwachten na aankoop?", a: "Bij de aankoop van uw nieuwe wagen, wordt bij ons de wagen uitgebreid gereinigd zowel binnen als buiten. Deze wordt grondig nagekeken en wordt gekeurd voor verkoop met een certificaat van meer dan 75 controlepunten, aanvraag tot inschrijving en Car-pass." },
      { q: "Zijn er aanpassingen mogelijk?", a: "Wij staan volledig open voor mogelijke aanpassingen op de auto, zaken zoals: ruiten tinten, trekhaken, velgen sets, bandensets, bestickering, wrapping,… Kan steeds uitgevoerd worden vooraf levering." },
      { q: "Wat is een uitgebreide reiniging?", a: "Onze wagens worden door een gespecialiseerde firma volledig gereinigd van binnen tot buiten. Zij zorgen ervoor dat de wagen zo dicht mogelijk naar nieuw wordt gebracht!" },
      { q: "Welke merken biedt TR Premium Cars aan?", a: "Wij bieden voornamelijk geselecteerde 'Premium' merken aan waaronder: BMW, Mercedes, Audi, Volkswagen, Mini, Maserati, Porsche, Jaguar, Tesla en Land Rover." },
      { q: "Kan ik mijn auto inruilen?", a: "Overnames zijn steeds mogelijk, wij kunnen ter plaatse de nodige informatie en foto's maken voor een overnameprijs." },
      { q: "Financiering", a: "Financiële leasings of rentings zijn mogelijk op onze BTW-wagens en wij hebben heel wat mogelijkheden. Wij kunnen u tevens ook helpen aan een financiering voor particulieren." },
    ],
  },
  contact: {
    overline: "Contact",
    title: "Neem",
    titleAccent: "contact",
    titleEnd: "op",
    intro:
      "Heeft u een vraag over één van onze wagens of wenst u een afspraak te maken? Wij staan voor u klaar.",
    phone: "Telefoon",
    email: "E-mail",
    showroom: "Showroom",
    hours: "Openingsuren",
    hoursValue: "Op afspraak — ma-vrij 9u-18u, za 10u-16u",
    formTitle: "Stuur ons een bericht",
    toastTitle: "Bericht verzonden",
    toastDesc: "Wij nemen zo snel mogelijk contact met u op.",
    whatsappCta: "Chat met ons",
  },
  buy: {
    overline: "Onze dienst",
    title: "Wij",
    titleAccent: "kopen",
    titleEnd: "uw auto",
    intro:
      "Wenst u uw huidige wagen te verkopen? Wij doen u een vrijblijvend en eerlijk overnamebod. Snel, professioneel en zonder zorgen.",
    bestPrice: "Eerlijke prijs",
    bestPriceText: "Wij bieden een eerlijke marktprijs voor uw wagen, transparant en zonder discussie.",
    fast: "Snelle afhandeling",
    fastText: "Binnen 48u krijgt u een eerste prijsindicatie. Snelle uitbetaling.",
    noWorries: "Correcte afhandeling",
    noWorriesText:
      "Geen discussie achteraf — een eerlijke prijs en correcte afhandeling van A tot Z.",
    howOverline: "Zo werkt het",
    howTitle: "4 eenvoudige stappen",
    step1Title: "Stuur ons de details",
    step1Text:
      "Vul het formulier in met merk, model, bouwjaar en kilometerstand. Voeg eventueel foto's toe.",
    step2Title: "Vrijblijvende prijsindicatie",
    step2Text:
      "Binnen 48 uur ontvangt u een eerste prijsindicatie via e-mail of telefoon.",
    step3Title: "Inspectie ter plaatse",
    step3Text:
      "Wij komen de wagen ter plaatse bekijken of u brengt deze langs onze showroom in Lede.",
    step4Title: "Directe uitbetaling",
    step4Text: "Akkoord met de prijs? Wij regelen het papierwerk en betalen direct uit.",
    formTitle: "Vraag een offerte aan",
    brand: "Merk",
    model: "Model",
    year: "Bouwjaar",
    firstRegistration: "1e inschrijving (MM/JJJJ)",
    km: "Kilometerstand",
    priceExpectation: "Prijsverwachting (€)",
    vatYes: "BTW-wagen: Ja",
    vatNo: "BTW-wagen: Nee",
    optionsTitle: "Opties & uitrusting",
    photosTitle: "Foto's van uw wagen",
    addPhotos: "Foto's toevoegen",
    uploading: "Uploaden...",
    uploadFailed: "Upload mislukt",
    extra: "Bijkomende info...",
    send: "Verstuur aanvraag",
    free: "Vrijblijvend & 100% transparant",
    toastTitle: "Aanvraag ontvangen",
    toastDesc: "Wij maken zo snel mogelijk een vrijblijvende offerte op.",
  },
  sell: {
    overline: "Onze dienst",
    title: "Verkoop",
    titleAccent: "mijn",
    titleEnd: "auto",
    intro:
      "Wij commercialiseren uw wagen via onze kanalen en netwerk. Zo bereikt uw wagen sneller de juiste koper, aan de beste prijs.",
    reach: "Maximaal bereik",
    reachText:
      "Uw wagen wordt geadverteerd via onze website, AutoScout24, 2dehands en sociale media.",
    photos: "Professionele foto's",
    photosText:
      "Wij maken professionele foto's en een uitgebreide beschrijving om uw wagen optimaal te presenteren.",
    higherPrice: "Hogere verkoopprijs",
    higherPriceText:
      "Door ons netwerk en marketing realiseren wij gemiddeld een hogere verkoopprijs.",
    formTitle: "Bezorg ons uw wagen",
    formSub: "Vul onderstaande gegevens in en wij contacteren u zo snel mogelijk.",
    askingPrice: "Gewenste vraagprijs (€)",
    options: "Opties & uitrusting...",
    addPhotos: "Foto's toevoegen (max 10 MB)",
    noSale: "Geen verkoop, geen kosten",
    toastTitle: "Aanvraag ontvangen",
    toastDesc: "Wij nemen contact op om uw wagen te commercialiseren.",
  },
  financing: {
    overline: "Financiering",
    title: "Maandelijks",
    titleAccent: "budget",
    intro:
      "Financiële leasings, rentings en consumentenkredieten zijn mogelijk. Bereken eenvoudig uw maandelijkse betaling.",
    calcTitle: "Rekenmodule",
    price: "Aankoopprijs",
    down: "Aanbetaling",
    duration: "Looptijd",
    durationUnit: "maanden",
    rate: "Rentevoet (JKP)",
    estimate: "Geschatte maandlast",
    disclaimer:
      "Indicatief & onder voorbehoud van goedkeuring. Geen contractuele waarde.",
    proposalTitle: "Persoonlijk voorstel",
    askProposal: "Vraag voorstel",
    applyDirect: "Direct aanvragen via Financo",
    applyDirectHint: "Dien meteen een online financieringsaanvraag in bij onze partner Financo — snel & vrijblijvend.",
    optionsTitle: "Mogelijkheden",
    opt1: "Financiële leasing op BTW-wagens",
    opt2: "Operationele renting voor zelfstandigen",
    opt3: "Consumentenkrediet voor particulieren",
    opt4: "Inruil mogelijk: meer wagen, minder maandlast",
    opt5: "Maatwerk: looptijden van 12 tot 84 maanden",
    subject: "Aanvraag financieringsvoorstel",
    toastTitle: "Aanvraag verzonden",
    toastDesc: "Wij nemen contact op met een persoonlijk financieringsvoorstel.",
    legalWarning: "Let op, geld lenen kost ook geld.",
    legalTitle: "Wettelijke vermeldingen",
    legalBody:
      "De getoonde berekening is louter indicatief en heeft geen contractuele waarde. Het uiteindelijke krediet en de rentevoet zijn afhankelijk van een dossierstudie en goedkeuring door de kredietgever. Onder voorbehoud van aanvaarding en wederzijds akkoord.",
    legalBroker:
      "TR Premium Cars treedt NIET op als kredietbemiddelaar en biedt zelf geen krediet aan. Wij brengen u op verzoek in contact met een erkende, FSMA-geregistreerde kredietmakelaar die uw dossier behandelt en goedkeurt.",
    legalCompany: "TR Premium Cars Comm.V · Maatschappelijke zetel: Wichelsesteenweg 100, 9340 Lede · BTW BE0696775051",
  },
  upcoming: {
    overline: "Binnenkort beschikbaar",
    title1: "Onze",
    titleAccent: "verwachte",
    title2: "wagens",
    lead: "Een eerste blik op de wagens die binnenkort in onze showroom arriveren. Reserveer als eerste of laat u verwittigen zodra ze beschikbaar zijn.",
    empty: "Momenteel zijn er geen verwachte wagens. Bekijk ons huidige aanbod of laat u verwittigen.",
    notifyTitle: "Mij verwittigen",
    notifyLead: "Vul het formulier in en wij contacteren u zodra de gewenste wagen beschikbaar is.",
    notifyCta: "Verwittig mij",
    notifySent: "Bedankt!",
    notifySentDesc: "We nemen zo snel mogelijk contact met u op.",
    carSelect: "Welke wagen?",
    noSpecificCar: "Geen specifieke wagen",
  },
  aftersales: {
    overline: "Diensten",
    heroTitle1: "Naverkoop &",
    heroTitleAccent: "personalisatie",
    heroTitle2: "",
    heroLead:
      "Van onderhoud tot detailing — we ontzorgen u ook na de aankoop. Hieronder vindt u onze diensten voor naverkoop, personalisatie en uitgebreide garantie.",
    afterSalesTitle: "Naverkoop",
    afterSalesLead:
      "Voor onderhoud, herstellingen en banden werken wij samen met onze partnergarage die naast onze showroom gelegen is.",
    afterSales1: "Onderhoud",
    afterSales2: "Herstellingen en mechanische interventies",
    afterSales3: "Banden, opslag en seizoenswissel",
    partnerLabel: "Partnergarage",
    partnerNote:
      "Garage VW Lede ligt op een steenworp van onze showroom.",
    customizationTitle: "Personalisatie",
    customizationLead:
      "Wenst u bij de aankoop van uw wagen extra's? Wij regelen het voor u, in samenwerking met gespecialiseerde partners.",
    custom1: "PPF (Paint Protection Film)",
    custom2: "Detailing: polieren, ceramic coating, dieptereiniging",
    custom3: "Trekhaak (vast of afneembaar)",
    custom4: "Ruiten tinten & chrome-delete",
    custom5: "Wrappen (volledig of accenten)",
    custom6: "Velgen & banden op maat",
    warrantyTitle: "Garantie",
    warrantyLead:
      "Op al onze stockwagens is standaard 12 maanden wettelijke waarborg van toepassing. Daarnaast bieden wij commerciële uitbreidingen aan.",
    warranty1: "12 maanden wettelijke waarborg standaard inbegrepen",
    warranty2: "Commerciële garantie uitbreidbaar tot 2, 3 of 4 jaar",
    warranty3: "Toepasbaar via onze eigen naverkoopdienst en partnergarages",
    ctaTitle1: "Klaar voor een",
    ctaTitleAccent: "afspraak",
    ctaText:
      "Neem contact op voor een persoonlijk gesprek of vraag een offerte aan voor onderhoud, personalisatie of een uitgebreide garantie.",
  },
  sold: {
    overline: "Verkocht",
    title: "Eerder",
    titleAccent: "verkochte",
    titleEnd: "wagens",
    intro:
      "Een greep uit eerder verkochte wagens. Op zoek naar iets gelijkaardigs? Wij vinden het voor u op aanvraag.",
    sold: "VERKOCHT",
    ctaTitle: "Zoekt u een specifieke wagen?",
    ctaText:
      "Door ons uitgebreide netwerk vinden wij ook wagens op aanvraag. Laat ons weten wat u zoekt en wij gaan voor u op zoek.",
    contactUs: "Contacteer ons",
  },
  tradeIn: {
    overline: "Overname",
    title: "Wij nemen uw",
    titleAccent: "wagen",
    titleEnd: "over",
    intro:
      "Wenst u uw huidige wagen in te ruilen of te verkopen? Wij bieden u twee duidelijke oplossingen aan, afhankelijk van uw wagen.",
    track1Badge: "Optie 1",
    track1Title: "Past uw wagen in onze stock?",
    track1Lead:
      "Beantwoordt uw wagen aan onze stockvoorwaarden (jonger dan 8 jaar, goede staat, binnen onze merken, geen hoge kilometerstand,...), dan kunnen wij u online een prijsindicatie geven. Vul het formulier hieronder in met alle informatie en duidelijke foto's.",
    track1Bullet1: "Snelle online prijsindicatie",
    track1Bullet2: "Geen verplaatsing nodig",
    track1Bullet3: "Rechtstreeks contact met de zaakvoerder",
    track1Cta: "Vraag prijsindicatie aan",
    track2Badge: "Optie 2",
    track2Title: "Valt uw wagen buiten onze stockvoorwaarden?",
    track2Lead:
      "Geen probleem. Tijdens een afspraak in onze showroom taxeren wij uw wagen ter plaatse. Past hij niet in onze eigen voorraad, dan plaatsen wij de wagen voor u op een van de grootste autohandelaarsplatforms in Europa, zodat u steeds een correcte en eerlijke overnameprijs ontvangt.",
    track2Bullet1: "Persoonlijke taxatie ter plaatse",
    track2Bullet2: "Toegang tot internationaal handelaarsnetwerk",
    track2Bullet3: "Een eerlijke marktprijs voor uw wagen",
    track2Cta: "Plan een afspraak",
    formTitle: "Vraag een prijsindicatie",
    formSub:
      "Vul onderstaand formulier zo volledig mogelijk in. Hoe meer informatie en foto's, hoe accurater onze prijsindicatie.",
  },
  footer: {
    nav: "Navigatie",
    services: "Diensten",
    contact: "Contact",
    faq: "FAQ",
    rights: "All rights reserved.",
  },
  login: {
    backToWebsite: "Terug naar website",
    title: "Admin",
    titleAccent: "Login",
    sub: "Log in om uw voorraad en aanvragen te beheren.",
    btn: "Aanmelden met Google",
    loading: "AANMELDEN...",
    failed: "Login mislukt",
  },
  admin: {
    back: "Terug",
    loading: "Laden...",
    newCar: "Nieuwe auto",
    editCar: "Auto",
    editing: "bewerken",
    save: "Opslaan",
    saving: "Opslaan...",
    cancel: "Annuleren",
    title: "Titel",
    brand: "Merk",
    model: "Model",
    brandPlaceholder: "Begin te typen of kies...",
    modelPlaceholder: "Kies of typ...",
    modelPlaceholderEmpty: "bv. A4, Model 3, Cayenne...",
    priceLabel: "Prijs (€) - leeg = op aanvraag",
    firstReg: "1e inschrijving (MM/JJJJ)",
    firstRegPh: "bv. 03/2022",
    km: "Kilometerstand",
    kmPh: "bv. 45000",
    transmission: "Transmissie",
    transAuto: "Automaat",
    transManual: "Manueel",
    fuel: "Brandstof",
    body: "Carrosserie",
    horsepower: "Vermogen (pk)",
    horsepowerPh: "bv. 184",
    engineSize: "Cilinderinhoud (cc)",
    engineSizePh: "bv. 1998",
    carpass: "Car-Pass link (URL)",
    colorExt: "Kleur exterieur",
    colorExtPh: "bv. Saphire Black Metallic",
    colorInt: "Kleur interieur",
    colorIntPh: "bv. Cognac leder",
    statusBadge: "Status badge (toon op kaart)",
    readyDesc: "Klaar voor afhaling",
    reservedDesc: "In reservatie",
    preparationDesc: "In voorbereiding",
    vatDeductibleDesc: "BTW aftrekbaar (professionele aankoop)",
    upcomingDesc: "Binnenkort beschikbaar (nog niet in voorraad)",
    expectedDate: "Verwacht beschikbaar",
    expectedDatePh: "bv. Juli 2026",
    description: "Beschrijving",
    imagesTitle: "Afbeeldingen",
    photos: "foto's",
    dropPhotos: "Sleep foto's hierheen of klik om te kiezen",
    dropPhotosHint: "Selecteer meerdere foto's tegelijk (Ctrl/Cmd + klik) — max 12 MB per foto",
    uploading: "Uploaden...",
    pasteUrl: "Of plak een afbeelding URL",
    mainPhotoHint: "Eerste foto = hoofdfoto. Sleep om volgorde te wijzigen.",
    mainBadge: "HOOFD",
    optionsTitle: "Opties & uitrusting",
    selected: "geselecteerd",
    addCustomOption: "Eigen optie toevoegen",
    customOptionPh: "Aangepaste optie...",
    selectedOptions: "Geselecteerde opties",
    saved: "Opgeslagen",
    savedDesc: "De wagen is bijgewerkt.",
    createFailed: "Aanmaken mislukt",
    updateFailed: "Bijwerken mislukt",
  },
};

const fr = {
  common: {
    explore: "DÉCOUVRIR",
    discover: "DÉCOUVRIR",
    view: "Voir",
    viewAll: "Voir tout",
    contactUs: "Nous contacter",
    sendMessage: "Envoyer",
    loading: "Chargement...",
    of: "sur",
    photos: "photos",
    showAll: "Voir toutes les",
    notFound: "Introuvable",
    backTo: "Retour à",
    name: "Nom",
    email: "E-mail",
    phone: "Téléphone",
    subject: "Sujet",
    message: "Message",
    sending: "Envoi...",
    submit: "Envoyer",
    yourName: "Votre nom",
    home: "Accueil",
    callUs: "Appelez-nous",
    emailUs: "Envoyer un e-mail",
    requestQuote: "Demander un devis",
    onAppointment: "Uniquement sur rendez-vous",
    perCar: "Par voiture",
    moreInfo: "Plus d'info",
  },
  nav: {
    offer: "Offre",
    services: "Services",
    ourCars: "Nos voitures",
    buyYourCar: "Nous achetons votre voiture",
    sellMyCar: "Vendre ma voiture",
    tradeIn: "Reprise",
    aftersales: "Après-vente & personnalisation",
    upcoming: "Bientôt",
    financing: "Financement",
    sold: "Vendus",
    about: "À propos",
    contact: "Contact",
    login: "Connexion",
  },
  home: {
    badge: "Concessionnaire premium depuis 2018",
    heroLine1: "Trouvez ici la voiture",
    heroLine2: "qui vous ressemble.",
    heroLine3: "Premium, prête à rouler.",
    heroSubtitle1:
      "Accompagnement personnalisé, sélection premium et",
    heroSubtitle2: "garantie légale de 12 mois",
    heroSubtitle3:
      "— de votre première visite à bien au-delà de l'achat.",
    seeStock: "Voir le stock",
    statsYears: "Années d'expérience",
    statsSold: "Voitures vendues",
    statsShowroom: "Showroom Lede",
    statsWarranty: "Garantie",
    months: "mois",
    scroll: "Faites défiler",
    stockOverline: "Notre stock",
    buyOverline: "Vendez-nous",
    sellOverline: "Nous vendons pour vous",
    premiumOverline: "Sélectionnées avec soin",
    premiumTitle: "Voitures",
    premiumTitleAccent: "premium",
    fullOffer: "Offre complète",
    viewCars: "Voir {n} voitures",
    brandsLine: "Nous sélectionnons uniquement les meilleures marques",
    welcomeAt: "Bienvenue chez",
    aboutTitle: "À",
    aboutTitleAccent: "propos",
    aboutText:
      "Des voitures de qualité des meilleures marques, avec tout le soin et la garantie nécessaires. Chez TR Premium Cars, vous êtes en contact direct avec le gérant pour une expérience d'achat personnalisée et transparente.",
    aboutPoint1: "Meilleur rapport qualité/prix",
    aboutPoint2: "Voitures sélectionnées avec soin",
    aboutPoint3: "Garantie légale de 12 mois incluse",
    aboutPoint4: "Contact personnel et professionnel",
    aboutCta: "Notre histoire",
    yearsExp: "ans d'expérience",
    valuesOverline: "Nos valeurs et normes",
    valuesTitle: "Acheter en confiance",
    valuesText:
      "Acheter chez TR Premium Cars, c'est acheter en confiance. Nous sélectionnons uniquement les meilleurs véhicules aux meilleurs prix.",
    valueShowroomTitle: "Showroom 600 m²",
    valueShowroomText:
      "Toutes nos voitures sont visibles à l'intérieur dans un espace entièrement éclairé.",
    valueQualityTitle: "Qualité supérieure",
    valueQualityText:
      "Nous ne sélectionnons que des voitures de qualité et attrayantes, toutes avec un historique d'entretien.",
    valueAdviceTitle: "Conseils personnalisés",
    valueAdviceText:
      "En tant que client, vous êtes en contact direct avec le gérant : une seule personne pour le suivi.",
    valueTradeTitle: "Reprises",
    valueTradeText:
      "Nous essayons toujours de vous donner le meilleur prix pour votre voiture de reprise. Même pour les voitures plus anciennes, nous collaborons avec une plateforme automobile internationale afin de proposer les meilleurs tarifs.",
    testimonialsOverline: "Clients satisfaits",
    testimonialsTitle: "Ce que disent nos clients",
    ctaTitle1: "Prêt pour votre",
    ctaTitleAccent: "prochaine",
    ctaTitle2: "voiture ?",
    ctaText:
      "Venez nous voir dans notre showroom de 600 m² à Lede, ou appelez-nous pour un entretien sans engagement.",
    makeAppointment: "Prendre rendez-vous",
    viewCarsShort: "Voir les voitures",
  },
  stock: {
    title: "Notre",
    titleAccent: "Stock",
    keyword: "Mot-clé",
    readyOnly: "Ready",
    brand: "Marque",
    fuel: "Carburant",
    body: "Carrosserie",
    clear: "Tout effacer",
    results: "Résultats",
    sortBy: "Trier :",
    sortNewest: "Plus récent",
    sortPriceAsc: "Prix (croissant)",
    sortPriceDesc: "Prix (décroissant)",
    sortYearDesc: "Année (récent)",
    sortKmAsc: "Kilométrage (bas)",
    noResults: "Aucun résultat trouvé.",
    loadFailedTitle: "Impossible de charger les voitures",
    loadFailedDesc: "Vérifiez votre connexion internet et réessayez.",
    retry: "Réessayer",
    all: "Tous",
    reset: "Réinit.",
    resetFilters: "Réinitialiser les filtres",
    ready: "READY!",
    reserved: "RÉSERVÉ!",
    inPreparation: "EN PRÉPARATION!",
    upcoming: "BIENTÔT!",
    priceOnRequest: "Prix sur demande",
  },
  car: {
    backToStock: "Retour au stock",
    showAllPhotos: "Voir les {n} photos",
    noImage: "Pas d'image",
    notFound: "Voiture introuvable",
    backToStockShort: "← Retour au stock",
    year: "Année",
    km: "Kilométrage",
    transmission: "Transmission",
    bodyType: "Carrosserie",
    brand: "Marque",
    model: "Modèle",
    warranty: "Garantie",
    months12: "12 mois",
    description: "Description",
    options: "Équipements & options",
    optionsHeader: "Équipement & options",
    allPhotos: "Toutes les photos",
    price: "Prix",
    askAboutThisCar: "Question sur cette voiture",
    sendEmail: "Envoyer un e-mail",
    financoCta: "Ou faites une demande directe via Financo",
    relatedCars: "Voitures similaires",
    legalWarranty: "Garantie légale de 12 mois",
    cleaning: "Nettoyage complet intérieur et extérieur",
    carPass: "Car-pass & 75+ points de contrôle",
    carPassLink: "Voir le Car-Pass",
    vatDeductible: "TVA déductible",
    horsepower: "Puissance",
    engineSize: "Cylindrée",
    hp: "ch",
    cc: "cc",
    yourMessage: "Votre message...",
    sendInquiry: "Envoyer",
    fuel: "Carburant",
    firstReg: "1ère immatriculation",
    colorExt: "Couleur extérieure",
    colorInt: "Couleur intérieure",
    inquirySubject: "Question sur",
    inquiryToast: "Message envoyé",
    inquiryToastDesc: "Nous vous contactons dès que possible.",
    sendFailed: "Échec de l'envoi",
    sendFailedDesc: "Réessayez ou appelez-nous.",
  },
  about: {
    overline: "Qui sommes-nous",
    title: "À",
    titleAccent: "propos",
    intro:
      "Bienvenue chez TR Premium Cars, où nous garantissons des voitures de qualité aux meilleurs prix du marché.",
    quote:
      '"On ne peut pas acheter le bonheur, mais on peut acheter des voitures, ce qui revient un peu au même."',
    storyP1:
      "Thibault Rasschaert a fondé TR Premium Cars il y a quelques années, animé par une grande passion pour les voitures et l'entrepreneuriat. En 2017, à 18 ans, il a commencé l'achat-revente de voitures d'occasion ; la première fut une Lexus IS F-Sport.",
    storyP2:
      "Dès lors, il a voulu mettre TR Premium Cars sur la carte. Il a été accompagné par la fédération Traxio et 2 garages réputés pour le contrôle et l'entretien des véhicules.",
    statsYears: "Années d'expérience",
    statsOnRequest: "Voitures sur demande",
    statsSold: "Voitures vendues",
    statsImports: "Imports sur demande",
    timelineOverline: "Notre histoire",
    timelineTitle: "Chronologie",
    hofOverline: "Hall of Fame",
    hofTitle: "Des voitures",
    hofTitleAccent: "d'exception",
    hofIntro: "Une sélection de véhicules exceptionnels passés entre nos mains — chacun livré avec le même soin et la même passion.",
    hofBadge: "Vendu",
    timeline: [
      { year: "2017", title: "Vente de la première voiture", text: "Une Lexus IS300h F Sport, une voiture magnifique que mon père voulait vendre après 4 ans comme voiture de société. J'ai égalé le prix de reprise du garage et vendu la voiture moi-même 3 semaines plus tard." },
      { year: "2018", title: "Création de la société", text: "TR Premium Cars a été fondée le 5 juin 2018 avec un focus sur des voitures magnifiques et qualitatives, et une politique de garantie correcte." },
      { year: "2023", title: "Ouverture du showroom à Lede", text: "Après avoir développé TR Premium Cars pendant des années et cherché un showroom accessible, nous nous installons à Lede, Kleiweg 27 !" },
      { year: "2024", title: "Agrandissement du showroom", text: "Notre showroom actuel a doublé de surface pour atteindre près de 600 m² ! Toutes nos voitures en stock y sont stockées en sécurité et au sec." },
      { year: "2025", title: "Ascenseurs de parking", text: "Ces ascenseurs de parking de qualité permettent un stockage vertical accru ; cet investissement garantit que les voitures restent au sec et soignées." },
    ],
    faqOverline: "FAQ",
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Quelle garantie est offerte ?", a: "Chaque prix inclut 12 mois de garantie légale. Vous achetez en toute tranquillité !" },
      { q: "Effectuez-vous des entretiens ?", a: "Nous nous concentrons uniquement sur l'achat-vente de voitures. Nous collaborons étroitement avec des garages spécialisés pour les contrôles, réparations et entretiens." },
      { q: "À quoi pouvons-nous nous attendre après l'achat ?", a: "À l'achat de votre nouvelle voiture, celle-ci est entièrement nettoyée intérieur et extérieur. Elle est minutieusement contrôlée et certifiée pour la vente avec plus de 75 points de contrôle, demande d'immatriculation et Car-pass." },
      { q: "Des modifications sont-elles possibles ?", a: "Nous sommes totalement ouverts aux modifications : teintage des vitres, attelages, sets de jantes, sets de pneus, stickers, wrapping… Toujours réalisables avant la livraison." },
      { q: "Qu'est-ce qu'un nettoyage approfondi ?", a: "Nos voitures sont entièrement nettoyées intérieur et extérieur par une firme spécialisée. Elles veillent à ce que la voiture soit la plus proche possible du neuf !" },
      { q: "Quelles marques TR Premium Cars propose-t-elle ?", a: "Nous proposons principalement des marques 'Premium' sélectionnées : BMW, Mercedes, Audi, Volkswagen, Mini, Maserati, Porsche, Jaguar, Tesla et Land Rover." },
      { q: "Puis-je reprendre ma voiture ?", a: "Les reprises sont toujours possibles, nous pouvons venir sur place pour les informations et photos nécessaires à un prix de reprise." },
      { q: "Financement", a: "Le leasing financier ou la location sont possibles sur nos voitures TVA, et nous avons beaucoup d'options. Nous pouvons aussi vous aider à obtenir un financement particulier." },
    ],
  },
  contact: {
    overline: "Contact",
    title: "Nous",
    titleAccent: "contacter",
    titleEnd: "",
    intro:
      "Une question sur l'une de nos voitures ou envie d'un rendez-vous ? Nous sommes à votre service.",
    phone: "Téléphone",
    email: "E-mail",
    showroom: "Showroom",
    hours: "Heures d'ouverture",
    hoursValue: "Sur rendez-vous — lun-ven 9h-18h, sam 10h-16h",
    formTitle: "Envoyez-nous un message",
    toastTitle: "Message envoyé",
    toastDesc: "Nous vous contactons dès que possible.",
  },
  buy: {
    overline: "Notre service",
    title: "Nous",
    titleAccent: "achetons",
    titleEnd: "votre voiture",
    intro:
      "Vous souhaitez vendre votre voiture ? Nous vous faisons une offre de reprise honnête et sans engagement. Rapide, professionnel et sans souci.",
    bestPrice: "Meilleur prix",
    bestPriceText: "Nous offrons le meilleur prix du marché, en toute transparence.",
    fast: "Traitement rapide",
    fastText: "Sous 24h, vous recevez une première estimation. Paiement rapide.",
    noWorries: "Sans souci",
    noWorriesText:
      "Nous nous occupons de toutes les démarches : papiers, radiation de plaque et transport.",
    howOverline: "Comment ça marche",
    howTitle: "4 étapes simples",
    step1Title: "Envoyez-nous les détails",
    step1Text:
      "Remplissez le formulaire avec marque, modèle, année et kilométrage. Ajoutez éventuellement des photos.",
    step2Title: "Estimation sans engagement",
    step2Text:
      "Sous 24 heures, vous recevez une première estimation par e-mail ou téléphone.",
    step3Title: "Inspection sur place",
    step3Text:
      "Nous venons inspecter la voiture sur place ou vous l'amenez à notre showroom de Lede.",
    step4Title: "Paiement immédiat",
    step4Text:
      "Accord sur le prix ? Nous gérons les papiers et payons immédiatement.",
    formTitle: "Demander un devis",
    brand: "Marque",
    model: "Modèle",
    year: "Année",
    firstRegistration: "1ère immatriculation (MM/AAAA)",
    km: "Kilométrage",
    priceExpectation: "Prix attendu (€)",
    vatYes: "Voiture TVA : Oui",
    vatNo: "Voiture TVA : Non",
    optionsTitle: "Options & équipements",
    photosTitle: "Photos de votre voiture",
    addPhotos: "Ajouter des photos",
    uploading: "Téléchargement...",
    uploadFailed: "Échec du téléchargement",
    extra: "Informations complémentaires...",
    send: "Envoyer la demande",
    free: "Sans engagement & 100% transparent",
    toastTitle: "Demande reçue",
    toastDesc: "Nous préparons une offre sans engagement au plus vite.",
  },
  sell: {
    overline: "Notre service",
    title: "Vendre",
    titleAccent: "ma",
    titleEnd: "voiture",
    intro:
      "Nous commercialisons votre voiture via nos canaux et notre réseau, pour atteindre rapidement le bon acheteur au meilleur prix.",
    reach: "Portée maximale",
    reachText:
      "Votre voiture est annoncée via notre site, AutoScout24, 2dehands et les réseaux sociaux.",
    photos: "Photos professionnelles",
    photosText:
      "Nous réalisons des photos pro et une description détaillée pour présenter votre voiture sous son meilleur jour.",
    higherPrice: "Prix de vente plus élevé",
    higherPriceText:
      "Grâce à notre réseau et marketing, nous obtenons en moyenne un meilleur prix de vente.",
    formTitle: "Confiez-nous votre voiture",
    formSub: "Remplissez les détails et nous vous recontactons rapidement.",
    askingPrice: "Prix demandé (€)",
    options: "Options & équipements...",
    addPhotos: "Ajouter des photos (max 10 MB)",
    noSale: "Pas de vente, pas de frais",
    toastTitle: "Demande reçue",
    toastDesc: "Nous vous contactons pour commercialiser votre voiture.",
  },
  financing: {
    overline: "Financement",
    title: "Budget",
    titleAccent: "mensuel",
    intro:
      "Leasings financiers, rentings et crédits à la consommation possibles. Calculez facilement votre mensualité.",
    calcTitle: "Calculateur",
    price: "Prix d'achat",
    down: "Acompte",
    duration: "Durée",
    durationUnit: "mois",
    rate: "Taux (TAEG)",
    estimate: "Mensualité estimée",
    disclaimer: "Indicatif & sous réserve d'acceptation. Aucune valeur contractuelle.",
    proposalTitle: "Proposition personnalisée",
    askProposal: "Demander une proposition",
    applyDirect: "Demande directe via Financo",
    applyDirectHint: "Soumettez votre demande de financement en ligne directement chez notre partenaire Financo — rapide & sans engagement.",
    optionsTitle: "Possibilités",
    opt1: "Leasing financier sur voitures TVA",
    opt2: "Renting opérationnel pour indépendants",
    opt3: "Crédit à la consommation pour particuliers",
    opt4: "Reprise possible : plus de voiture, moins de mensualités",
    opt5: "Sur mesure : durées de 12 à 84 mois",
    subject: "Demande de proposition de financement",
    toastTitle: "Demande envoyée",
    toastDesc: "Nous vous contactons avec une proposition personnalisée.",
    legalWarning: "Attention, emprunter de l'argent coûte aussi de l'argent.",
    legalTitle: "Mentions légales",
    legalBody:
      "Le calcul présenté est purement indicatif et n'a aucune valeur contractuelle. Le crédit final et le taux dépendent d'une étude de dossier et de l'approbation du prêteur. Sous réserve d'acceptation et d'accord mutuel.",
    legalBroker:
      "TR Premium Cars N'AGIT PAS comme intermédiaire de crédit et ne propose pas elle-même de crédit. Sur demande, nous vous mettons en contact avec un courtier de crédit agréé et enregistré auprès de la FSMA, qui traite et approuve votre dossier.",
    legalCompany: "TR Premium Cars Comm.V · Siège social : Wichelsesteenweg 100, 9340 Lede · TVA BE0696775051",
  },
  upcoming: {
    overline: "Bientôt disponibles",
    title1: "Nos voitures",
    titleAccent: "attendues",
    title2: "",
    lead: "Un premier aperçu des voitures qui arrivent prochainement dans notre showroom. Réservez en avant-première ou demandez à être prévenu dès leur disponibilité.",
    empty: "Aucune voiture attendue pour le moment. Découvrez notre offre actuelle ou laissez-vous prévenir.",
    notifyTitle: "Me prévenir",
    notifyLead: "Remplissez le formulaire et nous vous contacterons dès que la voiture souhaitée sera disponible.",
    notifyCta: "Prévenez-moi",
    notifySent: "Merci !",
    notifySentDesc: "Nous vous contacterons dans les plus brefs délais.",
    carSelect: "Quelle voiture ?",
    noSpecificCar: "Pas de voiture spécifique",
  },
  aftersales: {
    overline: "Services",
    heroTitle1: "Après-vente &",
    heroTitleAccent: "personnalisation",
    heroTitle2: "",
    heroLead:
      "De l'entretien au detailing — nous restons à vos côtés après l'achat. Voici nos services d'après-vente, de personnalisation et de garantie étendue.",
    afterSalesTitle: "Après-vente",
    afterSalesLead:
      "Pour l'entretien, les réparations et les pneus, nous collaborons avec notre garage partenaire situé juste à côté de notre showroom.",
    afterSales1: "Entretien",
    afterSales2: "Réparations et interventions mécaniques",
    afterSales3: "Pneus, stockage et changement saisonnier",
    partnerLabel: "Garage partenaire",
    partnerNote:
      "Garage VW Lede se trouve à deux pas de notre showroom.",
    customizationTitle: "Personnalisation",
    customizationLead:
      "Vous souhaitez des options supplémentaires lors de l'achat de votre voiture ? Nous nous en occupons, en collaboration avec des partenaires spécialisés.",
    custom1: "PPF (film de protection peinture)",
    custom2: "Detailing : polissage, traitement céramique, nettoyage en profondeur",
    custom3: "Attelage (fixe ou amovible)",
    custom4: "Vitres teintées & chrome-delete",
    custom5: "Covering (total ou accents)",
    custom6: "Jantes & pneus sur mesure",
    warrantyTitle: "Garantie",
    warrantyLead:
      "Toutes nos voitures en stock bénéficient d'une garantie légale de 12 mois. Nous proposons également des extensions commerciales.",
    warranty1: "Garantie légale de 12 mois incluse de série",
    warranty2: "Garantie commerciale extensible à 2, 3 ou 4 ans",
    warranty3: "Applicable via notre service après-vente et nos garages partenaires",
    ctaTitle1: "Prêt pour un",
    ctaTitleAccent: "rendez-vous",
    ctaText:
      "Contactez-nous pour un entretien personnalisé ou demandez un devis pour de l'entretien, de la personnalisation ou une garantie étendue.",
  },
  sold: {
    overline: "Vendus",
    title: "Voitures",
    titleAccent: "précédemment",
    titleEnd: "vendues",
    intro:
      "Un aperçu de voitures précédemment vendues. À la recherche de similaire ? Nous le trouvons pour vous sur demande.",
    sold: "VENDU",
    ctaTitle: "Cherchez-vous une voiture spécifique ?",
    ctaText:
      "Grâce à notre vaste réseau, nous trouvons aussi des voitures sur demande. Dites-nous ce que vous cherchez.",
    contactUs: "Nous contacter",
  },
  tradeIn: {
    overline: "Reprise",
    title: "Nous reprenons",
    titleAccent: "votre",
    titleEnd: "véhicule",
    intro:
      "Vous souhaitez échanger ou vendre votre voiture actuelle ? Nous vous proposons deux solutions claires, selon votre véhicule.",
    track1Badge: "Option 1",
    track1Title: "Votre voiture entre-t-elle dans notre stock ?",
    track1Lead:
      "Si votre voiture répond à nos critères de stock (moins de 8 ans, bon état, parmi nos marques, kilométrage raisonnable,...), nous pouvons vous donner une indication de prix en ligne. Complétez le formulaire ci-dessous avec toutes les informations et des photos claires.",
    track1Bullet1: "Indication de prix rapide en ligne",
    track1Bullet2: "Aucun déplacement nécessaire",
    track1Bullet3: "Contact direct avec le gérant",
    track1Cta: "Demander une indication de prix",
    track2Badge: "Option 2",
    track2Title: "Votre voiture ne correspond pas à nos critères ?",
    track2Lead:
      "Pas de souci. Lors d'un rendez-vous dans notre showroom, nous évaluons votre véhicule sur place. S'il ne convient pas à notre propre stock, nous le mettons en vente sur l'une des plus grandes plateformes professionnelles d'Europe afin de vous garantir un prix de reprise juste et correct.",
    track2Bullet1: "Évaluation personnelle sur place",
    track2Bullet2: "Accès au réseau international de négociants",
    track2Bullet3: "Un prix de marché équitable",
    track2Cta: "Prendre rendez-vous",
    formTitle: "Demander une indication de prix",
    formSub:
      "Complétez le formulaire ci-dessous aussi complètement que possible. Plus d'informations et de photos = une indication de prix plus précise.",
  },
  footer: {
    nav: "Navigation",
    services: "Services",
    contact: "Contact",
    faq: "FAQ",
    rights: "Tous droits réservés.",
  },
  login: {
    backToWebsite: "Retour au site",
    title: "Connexion",
    titleAccent: "Admin",
    sub: "Connectez-vous pour gérer votre stock et vos demandes.",
    btn: "Se connecter avec Google",
    loading: "CONNEXION...",
    failed: "Échec de la connexion",
  },
  admin: {
    back: "Retour",
    loading: "Chargement...",
    newCar: "Nouvelle voiture",
    editCar: "Voiture",
    editing: "modifier",
    save: "Enregistrer",
    saving: "Enregistrement...",
    cancel: "Annuler",
    title: "Titre",
    brand: "Marque",
    model: "Modèle",
    brandPlaceholder: "Commencez à taper ou choisissez...",
    modelPlaceholder: "Choisissez ou tapez...",
    modelPlaceholderEmpty: "ex. A4, Model 3, Cayenne...",
    priceLabel: "Prix (€) - vide = sur demande",
    firstReg: "1ère immatriculation (MM/AAAA)",
    firstRegPh: "ex. 03/2022",
    km: "Kilométrage",
    kmPh: "ex. 45000",
    transmission: "Transmission",
    transAuto: "Automatique",
    transManual: "Manuelle",
    fuel: "Carburant",
    body: "Carrosserie",
    horsepower: "Puissance (ch)",
    horsepowerPh: "ex. 184",
    engineSize: "Cylindrée (cc)",
    engineSizePh: "ex. 1998",
    carpass: "Lien Car-Pass (URL)",
    colorExt: "Couleur extérieure",
    colorExtPh: "ex. Saphire Black Metallic",
    colorInt: "Couleur intérieure",
    colorIntPh: "ex. Cuir cognac",
    statusBadge: "Badge de statut (affiché sur la carte)",
    readyDesc: "Prête à être livrée",
    reservedDesc: "En réservation",
    preparationDesc: "En préparation",
    vatDeductibleDesc: "TVA déductible (achat professionnel)",
    upcomingDesc: "Bientôt disponible (pas encore en stock)",
    expectedDate: "Disponibilité prévue",
    expectedDatePh: "ex. Juillet 2026",
    description: "Description",
    imagesTitle: "Images",
    photos: "photos",
    dropPhotos: "Glissez vos photos ici ou cliquez pour choisir",
    dropPhotosHint: "Sélectionnez plusieurs photos à la fois (Ctrl/Cmd + clic) — max 12 Mo par photo",
    uploading: "Téléchargement...",
    pasteUrl: "Ou collez une URL d'image",
    mainPhotoHint: "Première photo = photo principale. Glissez pour réorganiser.",
    mainBadge: "PRINCIPALE",
    optionsTitle: "Options & équipements",
    selected: "sélectionné(s)",
    addCustomOption: "Ajouter une option personnalisée",
    customOptionPh: "Option personnalisée...",
    selectedOptions: "Options sélectionnées",
    saved: "Enregistré",
    savedDesc: "La voiture a été mise à jour.",
    createFailed: "Échec de la création",
    updateFailed: "Échec de la mise à jour",
  },
};

const en = {
  common: {
    explore: "EXPLORE",
    discover: "DISCOVER",
    view: "View",
    viewAll: "View all",
    contactUs: "Contact us",
    sendMessage: "Send",
    loading: "Loading...",
    of: "of",
    photos: "photos",
    showAll: "Show all",
    notFound: "Not found",
    backTo: "Back to",
    name: "Name",
    email: "Email",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    sending: "Sending...",
    submit: "Send",
    yourName: "Your name",
    home: "Home",
    callUs: "Call us",
    emailUs: "Send email",
    requestQuote: "Request quote",
    onAppointment: "By appointment only",
    perCar: "Per car",
    moreInfo: "More info",
  },
  nav: {
    offer: "Stock",
    services: "Services",
    ourCars: "Our cars",
    buyYourCar: "We buy your car",
    sellMyCar: "Sell my car",
    tradeIn: "Trade-in",
    aftersales: "Aftersales & customization",
    upcoming: "Upcoming",
    financing: "Financing",
    sold: "Sold",
    about: "About us",
    contact: "Contact",
    login: "Login",
  },
  home: {
    badge: "Premium dealer since 2018",
    heroLine1: "Find the car",
    heroLine2: "that fits you.",
    heroLine3: "Premium, ready to drive.",
    heroSubtitle1: "Personal guidance, premium selection and",
    heroSubtitle2: "12-month legal warranty",
    heroSubtitle3:
      "— from your first visit well beyond the purchase.",
    seeStock: "View stock",
    statsYears: "Years experience",
    statsSold: "Cars sold",
    statsShowroom: "Showroom Lede",
    statsWarranty: "Warranty",
    months: "mo",
    scroll: "Scroll",
    stockOverline: "Our stock",
    buyOverline: "Sell to us",
    sellOverline: "We sell for you",
    premiumOverline: "Carefully selected",
    premiumTitle: "Premium",
    premiumTitleAccent: "cars",
    fullOffer: "Full offer",
    viewCars: "View {n} cars",
    brandsLine: "We only select top brands",
    welcomeAt: "Welcome at",
    aboutTitle: "About",
    aboutTitleAccent: "us",
    aboutText:
      "Quality cars from top brands, with all the care and warranty needed. At TR Premium Cars you deal directly with the owner for a personal and transparent buying experience.",
    aboutPoint1: "Best value for money",
    aboutPoint2: "Carefully selected cars",
    aboutPoint3: "12-month legal warranty included",
    aboutPoint4: "Personal and professional contact",
    aboutCta: "Our story",
    yearsExp: "years experience",
    valuesOverline: "Our values and standards",
    valuesTitle: "Buy with confidence",
    valuesText:
      "Buying at TR Premium Cars means buying with confidence. We only select the best vehicles at the best prices.",
    valueShowroomTitle: "600 m² Showroom",
    valueShowroomText:
      "All our cars can be viewed indoors in a fully lit space, so you can take your time.",
    valueQualityTitle: "Top quality",
    valueQualityText:
      "We only select quality, appealing cars with full service history.",
    valueAdviceTitle: "Personal advice",
    valueAdviceText:
      "As a customer you deal directly with the owner — one person for follow-up.",
    valueTradeTitle: "Trade-ins",
    valueTradeText:
      "We always try to give you the best price for your trade-in. For older cars too, we partner with an international car platform to bring you the best prices.",
    testimonialsOverline: "Happy customers",
    testimonialsTitle: "What customers say",
    ctaTitle1: "Ready for your",
    ctaTitleAccent: "next",
    ctaTitle2: "car?",
    ctaText:
      "Visit our 600 m² showroom in Lede, or call us for a no-obligation chat. By appointment only.",
    makeAppointment: "Make appointment",
    viewCarsShort: "View cars",
  },
  stock: {
    title: "Our",
    titleAccent: "Stock",
    keyword: "Keyword",
    readyOnly: "Ready",
    brand: "Brand",
    fuel: "Fuel",
    body: "Body",
    clear: "Clear all",
    results: "Results",
    sortBy: "Sort:",
    sortNewest: "Newest",
    sortPriceAsc: "Price (low-high)",
    sortPriceDesc: "Price (high-low)",
    sortYearDesc: "Year (newest)",
    sortKmAsc: "Mileage (lowest)",
    noResults: "No results found.",
    loadFailedTitle: "Could not load the cars",
    loadFailedDesc: "Check your internet connection and try again.",
    retry: "Try again",
    all: "All",
    reset: "Reset",
    resetFilters: "Reset filters",
    ready: "READY!",
    reserved: "RESERVED!",
    inPreparation: "IN PREPARATION!",
    upcoming: "COMING SOON!",
    priceOnRequest: "Price on request",
  },
  car: {
    backToStock: "Back to stock",
    showAllPhotos: "Show all {n} photos",
    noImage: "No image",
    notFound: "Car not found",
    backToStockShort: "← Back to stock",
    year: "Year",
    km: "Mileage",
    transmission: "Transmission",
    bodyType: "Body",
    brand: "Brand",
    model: "Model",
    warranty: "Warranty",
    months12: "12 months",
    description: "Description",
    options: "Equipment & options",
    allPhotos: "All photos",
    price: "Price",
    askAboutThisCar: "Ask about this car",
    sendEmail: "Send email",
    financoCta: "Or apply directly via Financo",
    optionsHeader: "Equipment & options",
    relatedCars: "Similar cars",
    legalWarranty: "12-month legal warranty",
    cleaning: "Full interior and exterior cleaning",
    carPass: "Car-pass & 75+ check points",
    carPassLink: "View Car-Pass",
    vatDeductible: "VAT deductible",
    horsepower: "Horsepower",
    engineSize: "Engine size",
    hp: "hp",
    cc: "cc",
    yourMessage: "Your message...",
    sendInquiry: "Send",
    fuel: "Fuel",
    firstReg: "First registration",
    colorExt: "Exterior colour",
    colorInt: "Interior colour",
    inquirySubject: "Question about",
    inquiryToast: "Message sent",
    inquiryToastDesc: "We'll contact you as soon as possible.",
    sendFailed: "Sending failed",
    sendFailedDesc: "Try again or call us.",
  },
  about: {
    overline: "Who we are",
    title: "About",
    titleAccent: "us",
    intro:
      "Welcome to TR Premium Cars, where we guarantee quality cars at the best prices on the market.",
    quote:
      '"You can\'t buy happiness, but you can buy cars and that\'s kind of the same thing."',
    storyP1:
      "Thibault Rasschaert founded TR Premium Cars a few years ago, driven by a passion for cars and entrepreneurship. In 2017, at 18, he started buying and selling used cars; the first was a Lexus IS F-Sport.",
    storyP2:
      "From that moment he wanted to put TR Premium Cars on the map. He was supported by the Traxio federation and 2 reputable garages for vehicle inspection and maintenance.",
    statsYears: "Years experience",
    statsOnRequest: "Cars on request",
    statsSold: "Cars sold",
    statsImports: "Imports on request",
    timelineOverline: "Our history",
    timelineTitle: "Timeline",
    hofOverline: "Hall of Fame",
    hofTitle: "Cars that made",
    hofTitleAccent: "history",
    hofIntro: "A selection of exceptional cars that passed through our hands — each delivered with the same care and passion.",
    hofBadge: "Sold",
    timeline: [
      { year: "2017", title: "First car sold", text: "The Lexus IS300h F Sport, a beautiful car my father wanted to sell after 4 years as a company car. I matched the garage's trade-in price and sold the car myself 3 weeks later." },
      { year: "2018", title: "Company founded", text: "TR Premium Cars was founded on June 5th, 2018, focused on beautiful, quality cars and a fair warranty policy." },
      { year: "2023", title: "Showroom opening in Lede", text: "After years of building TR Premium Cars and searching for an accessible showroom, we settled at Kleiweg 27 in Lede!" },
      { year: "2024", title: "Showroom expansion", text: "Our current showroom was doubled in size to nearly 600 m²! All our stock is safely and dryly stored here until a new home is found." },
      { year: "2025", title: "Parking lifts", text: "These quality parking lifts allow more vertical storage; this investment keeps the cars dry and well-maintained for viewings and deliveries." },
    ],
    faqOverline: "FAQ",
    faqTitle: "Frequently asked questions",
    faqs: [
      { q: "What warranty is offered?", a: "Every price includes 12 months of legal warranty by default. So you can buy with peace of mind!" },
      { q: "Do you perform maintenance?", a: "We focus only on the purchase and sale of cars. We work closely with specialised garages for inspections, repairs and maintenance — customers can always go there." },
      { q: "What can we expect after purchase?", a: "When you buy your new car, it is thoroughly cleaned inside and out. It is meticulously inspected and certified for sale with over 75 control points, registration request and Car-pass." },
      { q: "Are modifications possible?", a: "We are fully open to modifications: window tinting, tow bars, wheel sets, tyre sets, decals, wrapping… Always doable before delivery." },
      { q: "What is a thorough cleaning?", a: "Our cars are fully cleaned inside and out by a specialised firm. They ensure the car is brought as close to new as possible!" },
      { q: "Which brands does TR Premium Cars offer?", a: "We mainly offer selected 'Premium' brands including: BMW, Mercedes, Audi, Volkswagen, Mini, Maserati, Porsche, Jaguar, Tesla and Land Rover." },
      { q: "Can I trade in my car?", a: "Trade-ins are always possible — we can come on-site for the information and photos needed for a trade-in price." },
      { q: "Financing", a: "Financial leasing or renting is possible on our VAT cars and we have many options. We can also help you arrange consumer financing." },
    ],
  },
  contact: {
    overline: "Contact",
    title: "Get",
    titleAccent: "in touch",
    titleEnd: "",
    intro:
      "Have a question about one of our cars or want to make an appointment? We're here for you.",
    phone: "Phone",
    email: "Email",
    showroom: "Showroom",
    hours: "Opening hours",
    hoursValue: "By appointment — Mon-Fri 9am-6pm, Sat 10am-4pm",
    formTitle: "Send us a message",
    toastTitle: "Message sent",
    toastDesc: "We'll contact you as soon as possible.",
    whatsappCta: "Chat with us",
  },
  buy: {
    overline: "Our service",
    title: "We",
    titleAccent: "buy",
    titleEnd: "your car",
    intro:
      "Want to sell your car? We make you a fair, no-obligation trade-in offer. Fast, professional and worry-free.",
    bestPrice: "Best price",
    bestPriceText: "We offer the best market price, transparent and fair.",
    fast: "Fast handling",
    fastText: "Within 24h you get a first price indication. Fast payout.",
    noWorries: "Worry-free",
    noWorriesText:
      "We handle all paperwork, license plate cancellation and transport.",
    howOverline: "How it works",
    howTitle: "4 simple steps",
    step1Title: "Send us the details",
    step1Text:
      "Fill in the form with make, model, year and mileage. Optionally add photos.",
    step2Title: "No-obligation estimate",
    step2Text: "Within 24 hours you receive a first estimate by email or phone.",
    step3Title: "On-site inspection",
    step3Text:
      "We come to inspect the car on-site or you bring it to our Lede showroom.",
    step4Title: "Immediate payout",
    step4Text:
      "Agree on the price? We handle the paperwork and pay out immediately.",
    formTitle: "Request a quote",
    brand: "Brand",
    model: "Model",
    year: "Year",
    firstRegistration: "First registration (MM/YYYY)",
    km: "Mileage",
    priceExpectation: "Price expectation (€)",
    vatYes: "VAT car: Yes",
    vatNo: "VAT car: No",
    optionsTitle: "Options & equipment",
    photosTitle: "Photos of your car",
    addPhotos: "Add photos",
    uploading: "Uploading...",
    uploadFailed: "Upload failed",
    extra: "Additional info...",
    send: "Send request",
    free: "No-obligation & 100% transparent",
    toastTitle: "Request received",
    toastDesc: "We'll prepare a no-obligation offer as soon as possible.",
  },
  sell: {
    overline: "Our service",
    title: "Sell",
    titleAccent: "my",
    titleEnd: "car",
    intro:
      "We market your car through our channels and network, reaching the right buyer faster at the best price.",
    reach: "Maximum reach",
    reachText:
      "Your car is advertised via our website, AutoScout24, 2dehands and social media.",
    photos: "Professional photos",
    photosText:
      "We take professional photos and write a detailed description to present your car at its best.",
    higherPrice: "Higher sale price",
    higherPriceText:
      "Thanks to our network and marketing, we achieve on average a higher sale price.",
    formTitle: "Entrust us with your car",
    formSub: "Fill in the details and we'll contact you as soon as possible.",
    askingPrice: "Asking price (€)",
    options: "Options & equipment...",
    addPhotos: "Add photos (max 10 MB)",
    noSale: "No sale, no fees",
    toastTitle: "Request received",
    toastDesc: "We'll contact you to market your car.",
  },
  financing: {
    overline: "Financing",
    title: "Monthly",
    titleAccent: "budget",
    intro:
      "Financial leasing, renting and consumer credit are possible. Easily calculate your monthly payment.",
    calcTitle: "Calculator",
    price: "Purchase price",
    down: "Down payment",
    duration: "Term",
    durationUnit: "months",
    rate: "Rate (APR)",
    estimate: "Estimated monthly payment",
    disclaimer:
      "Indicative & subject to approval. No contractual value.",
    proposalTitle: "Personal proposal",
    askProposal: "Request proposal",
    applyDirect: "Apply directly via Financo",
    applyDirectHint: "Submit an online financing application straight to our partner Financo — fast & non-binding.",
    optionsTitle: "Possibilities",
    opt1: "Financial lease on VAT cars",
    opt2: "Operational renting for self-employed",
    opt3: "Consumer credit for individuals",
    opt4: "Trade-in possible: more car, lower monthly cost",
    opt5: "Custom: terms from 12 to 84 months",
    subject: "Financing proposal request",
    toastTitle: "Request sent",
    toastDesc: "We'll contact you with a personal financing proposal.",
    legalWarning: "Warning: borrowing money also costs money.",
    legalTitle: "Legal notice",
    legalBody:
      "The calculation shown is purely indicative and has no contractual value. The final credit and rate depend on a file review and approval by the lender. Subject to acceptance and mutual agreement.",
    legalBroker:
      "TR Premium Cars DOES NOT act as a credit intermediary and does not offer credit itself. On request, we put you in touch with a licensed, FSMA-registered credit broker who handles and approves your file.",
    legalCompany: "TR Premium Cars Comm.V · Registered office: Wichelsesteenweg 100, 9340 Lede · VAT BE0696775051",
  },
  upcoming: {
    overline: "Coming soon",
    title1: "Our",
    titleAccent: "upcoming",
    title2: "cars",
    lead: "A first look at the cars arriving soon in our showroom. Be the first to reserve or get notified when they become available.",
    empty: "No upcoming cars at the moment. Browse our current stock or sign up to be notified.",
    notifyTitle: "Notify me",
    notifyLead: "Fill in the form and we'll get in touch the moment your preferred car becomes available.",
    notifyCta: "Notify me",
    notifySent: "Thank you!",
    notifySentDesc: "We'll get back to you as soon as possible.",
    carSelect: "Which car?",
    noSpecificCar: "No specific car",
  },
  aftersales: {
    overline: "Services",
    heroTitle1: "Aftersales &",
    heroTitleAccent: "customization",
    heroTitle2: "",
    heroLead:
      "From maintenance to detailing — we keep taking care of you after the purchase. Below you'll find our aftersales, customization and extended warranty services.",
    afterSalesTitle: "Aftersales",
    afterSalesLead:
      "For maintenance, repairs and tyres we work together with our partner garage, located right next to our showroom.",
    afterSales1: "Maintenance",
    afterSales2: "Repairs and mechanical interventions",
    afterSales3: "Tyres, storage and seasonal changeover",
    partnerLabel: "Partner garage",
    partnerNote:
      "Garage VW Lede is just a stone's throw from our showroom.",
    customizationTitle: "Customization",
    customizationLead:
      "Want to add extras when buying your car? We take care of it through specialised partners.",
    custom1: "PPF (Paint Protection Film)",
    custom2: "Detailing: polishing, ceramic coating, deep cleaning",
    custom3: "Tow bar (fixed or detachable)",
    custom4: "Window tinting & chrome-delete",
    custom5: "Wrapping (full or accents)",
    custom6: "Custom wheels & tyres",
    warrantyTitle: "Warranty",
    warrantyLead:
      "All our stock cars come with a standard 12-month legal warranty. We also offer commercial extensions.",
    warranty1: "12-month legal warranty included as standard",
    warranty2: "Commercial warranty extendable to 2, 3 or 4 years",
    warranty3: "Applicable through our own aftersales service and partner garages",
    ctaTitle1: "Ready for an",
    ctaTitleAccent: "appointment",
    ctaText:
      "Get in touch for a personal conversation or request a quote for maintenance, customization or an extended warranty.",
  },
  sold: {
    overline: "Sold",
    title: "Previously",
    titleAccent: "sold",
    titleEnd: "cars",
    intro:
      "A selection of previously sold cars. Looking for something similar? We can find it for you on request.",
    sold: "SOLD",
    ctaTitle: "Looking for a specific car?",
    ctaText:
      "Through our extensive network we can also find cars on request. Let us know what you're looking for.",
    contactUs: "Contact us",
  },
  tradeIn: {
    overline: "Trade-in",
    title: "We take over",
    titleAccent: "your",
    titleEnd: "car",
    intro:
      "Looking to trade in or sell your current car? We offer two clear options, depending on your vehicle.",
    track1Badge: "Option 1",
    track1Title: "Does your car fit our stock criteria?",
    track1Lead:
      "If your car meets our stock requirements (less than 8 years old, good condition, one of our brands, reasonable mileage,...), we can give you an online price indication. Fill in the form below with all the information and clear photos.",
    track1Bullet1: "Fast online price indication",
    track1Bullet2: "No travel required",
    track1Bullet3: "Direct contact with the owner",
    track1Cta: "Request a price indication",
    track2Badge: "Option 2",
    track2Title: "Doesn't your car meet our criteria?",
    track2Lead:
      "No problem. During an appointment at our showroom, we will appraise your car on the spot. If it doesn't fit our own stock, we'll list it on one of the largest professional dealer platforms in Europe to ensure you receive a fair and correct trade-in price.",
    track2Bullet1: "Personal on-site appraisal",
    track2Bullet2: "Access to international dealer network",
    track2Bullet3: "A fair market price for your car",
    track2Cta: "Book an appointment",
    formTitle: "Request a price indication",
    formSub:
      "Complete the form below as thoroughly as possible. More information and photos = a more accurate price indication.",
  },
  footer: {
    nav: "Navigation",
    services: "Services",
    contact: "Contact",
    faq: "FAQ",
    rights: "All rights reserved.",
  },
  login: {
    backToWebsite: "Back to website",
    title: "Admin",
    titleAccent: "Login",
    sub: "Log in to manage your stock and inquiries.",
    btn: "Sign in with Google",
    loading: "SIGNING IN...",
    failed: "Login failed",
  },
  admin: {
    back: "Back",
    loading: "Loading...",
    newCar: "New car",
    editCar: "Car",
    editing: "edit",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    title: "Title",
    brand: "Brand",
    model: "Model",
    brandPlaceholder: "Start typing or pick...",
    modelPlaceholder: "Pick or type...",
    modelPlaceholderEmpty: "e.g. A4, Model 3, Cayenne...",
    priceLabel: "Price (€) - empty = on request",
    firstReg: "First registration (MM/YYYY)",
    firstRegPh: "e.g. 03/2022",
    km: "Mileage",
    kmPh: "e.g. 45000",
    transmission: "Transmission",
    transAuto: "Automatic",
    transManual: "Manual",
    fuel: "Fuel",
    body: "Body",
    horsepower: "Power (hp)",
    horsepowerPh: "e.g. 184",
    engineSize: "Engine size (cc)",
    engineSizePh: "e.g. 1998",
    carpass: "Car-Pass link (URL)",
    colorExt: "Exterior colour",
    colorExtPh: "e.g. Saphire Black Metallic",
    colorInt: "Interior colour",
    colorIntPh: "e.g. Cognac leather",
    statusBadge: "Status badge (shown on card)",
    readyDesc: "Ready for delivery",
    reservedDesc: "Reserved",
    preparationDesc: "In preparation",
    vatDeductibleDesc: "VAT deductible (professional purchase)",
    upcomingDesc: "Coming soon (not yet in stock)",
    expectedDate: "Expected availability",
    expectedDatePh: "e.g. July 2026",
    description: "Description",
    imagesTitle: "Images",
    photos: "photos",
    dropPhotos: "Drag photos here or click to choose",
    dropPhotosHint: "Select multiple photos at once (Ctrl/Cmd + click) — max 12 MB per photo",
    uploading: "Uploading...",
    pasteUrl: "Or paste an image URL",
    mainPhotoHint: "First photo = main photo. Drag to reorder.",
    mainBadge: "MAIN",
    optionsTitle: "Options & equipment",
    selected: "selected",
    addCustomOption: "Add custom option",
    customOptionPh: "Custom option...",
    selectedOptions: "Selected options",
    saved: "Saved",
    savedDesc: "The car has been updated.",
    createFailed: "Create failed",
    updateFailed: "Update failed",
  },
};

export const translations = { nl, fr, en };
export const LANGUAGES = [
  { code: "nl", label: "NL", name: "Nederlands" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
];






